import { useIntl } from 'react-intl';
import style from './index.module.scss';
import { useLocation } from 'ice';
import Language from '../Language';
import { useRouter } from '@/hooks/useRouter';
import { useMemo } from 'react';
import { showLoginDrawer, showMy } from '../Drawer';
import { ClientHostType, DEVICE_TYPE, ROUTER_MAP } from '@/types';
import { getQueryStringByName, isGuesLogin } from '@/utils/helper';
import { useStore } from '@/store';
import cls from 'classnames';
import useSideBar, { showSideBarRouterListMap } from '@/hooks/useSideBar';
import { Icons } from '@/packages';
import IconAAcxlogo from '@/packages/iconfont/IconAAcxlogo';
import bonaLogo from '@/assets/img/bonaLogo.png';
import galaxyLogo from '@/assets/svg/galaxy_logo.svg';
// import IconLogo from '@/packages/iconfont/IconLogo';
import { useHeaderJump } from './hooks/useHeaderJump';
export const LoginItem = () => {
  const { baseObj, channel } = useStore();
  const isGues = isGuesLogin();

  const defaultImg = 'https://assets.alicdn.com/g/icirena/cdn/0.0.2/common/static/img/h5lark/userLogo.png';
  const clickDisable = !showSideBarRouterListMap?.[channel]?.includes(location.pathname as ROUTER_MAP);
  if (!baseObj.user?.account?.accountId) {
    // 未登陆
    return (
      <Icons.IconDenglu1
        className={style.loginImg}
        onClick={() => {
          if (!showSideBarRouterListMap?.[channel]?.includes(location.pathname as ROUTER_MAP)) {
            return;
          }

          showLoginDrawer();
        }}
      />
    );
  }
  if (isGues && getQueryStringByName('wapid') === 'HGZYYZZH_H5_PROD_S_MPS') {
    return (
      <div
        className={style.loginImg}
        onClick={() => {
          if (clickDisable) return;
          showLoginDrawer();
        }}
      >
        访
      </div>
    );
  }

  return (
    <div
      className={style.loginImg}
      onClick={() => {
        if (clickDisable) return;
        if (isGues) {
          showLoginDrawer();
        } else {
          showMy({});
        }
      }}
    >
      <img src={baseObj.user?.account?.headImgUrl || defaultImg} alt="" />
    </div>
  );
};

export default function Header() {
  const { jump } = useRouter();


  const location = useLocation();
  const intl = useIntl();
  const { device, channel } = useStore();
  const goBack = useHeaderJump();
  const { showSideBar, setShowSideBar } = useSideBar();
  const logoMap = useMemo(() => {
    return {
      [ClientHostType.acx]: <IconAAcxlogo className={style.logoItem} />,
      [ClientHostType.icirena]: (
        <div className={cls(style.galaxyLogoBg, style.noBgColor)}>
          <img src={bonaLogo} className={style.logoImg} />
        </div>
      ),
      [ClientHostType.galaxy]: (
        <div className={cls(style.galaxyLogoBg, style.noBgColor)}>
          <img src={galaxyLogo} className={style.galaxyLogoImg} />
        </div>
      ),
    }[channel];
  }, [channel]);

  const DrawerPageHideList = [
    ROUTER_MAP.USER_INDEX,
    ROUTER_MAP.ORDER_LIST,
    ROUTER_MAP.CARD_LIST,
    ROUTER_MAP.COUPON_LIST,
    ROUTER_MAP.AGREEMENT_PRIVACY,
    ROUTER_MAP.CARD_SELL,
  ];

  const showBack = useMemo(() => {
    const hideList = showSideBarRouterListMap?.[channel];
    return !hideList?.includes(location.pathname as ROUTER_MAP);
  }, [location]);

  const logoLeft = useMemo(() => {
    if (device === DEVICE_TYPE.PC && showSideBar) {
      return true;
    } else {
      return false;
    }
  }, [location, device, showSideBar]);

  if (DrawerPageHideList.includes(location.pathname as ROUTER_MAP)) {
    return null;
  }

  return (
    <div className={style.header}>
      {showBack && (
        <div
          className={style.left}
          onClick={goBack}
        >
          <Icons.IconFanhui />
          <span className={'h5-none pad-none'}>
            {intl.formatMessage({ id: 'iWeb.components.Header.Return', defaultMessage: '返回' })}
          </span>
        </div>
      )}
      {device !== DEVICE_TYPE.PC && !showBack && (
        <div
          className={style.menu}
          onClick={() => {
            setShowSideBar();
          }}
        >
          <Icons.IconZhankai />
        </div>
      )}

      <div
        className={cls(style.logo_container, {
          [style.logoLeft]: logoLeft,
        })}
      >
        <div
          className={style.logo}
          onClick={() => {
            jump(ROUTER_MAP.HOME);
          }}
        >
          {logoMap}
        </div>
      </div>
      <div className={style.right}>
        {channel !== ClientHostType.galaxy && (
          <div className={style.login}>
            <LoginItem />
          </div>
        )}
        <Language />
      </div>
    </div>
  );
}
